export default "__VITE_ASSET__2ee7b0ff__"